<template>
  <div class="meeting-page">
    <van-nav-bar title="空中课堂" left-arrow @click-left="$router.back()" />
    <div class="meeting-list">
        <button
          v-for="item in list"
          :key="item.id"
          type="button"
          class="meeting-card"
          @click="goDetail(item)"
        >
          <img v-if="item.image" :src="item.image" alt="" />
          <span>{{ item.title }}</span>
          <i>›</i>
        </button>
      <div v-if="!loading && !list.length" class="meeting-empty">暂无视频会议</div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage } from "@utils/goodsImage";

export default {
  name: "VideoMeeting",
  data() {
    return {
      loading: false,
      list: []
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        name: "videoMeetingDetail",
        query: { id: item.id }
      });
    },
    loadList() {
      this.loading = true;
      request
        .get("/api/v1/video/list", {}, { login: false })
        .then(res => {
          const payload = res && res.data ? res.data : res;
          this.list = ((payload && payload.data) || []).map(item => {
            return Object.assign({}, item, {
              image: goodsImage(item.image)
            });
          });
        })
        .catch(() => {
          this.list = [];
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.meeting-page {
  min-height: 100vh;
  background: #f2f2f2;
}

.meeting-page /deep/ .van-nav-bar {
  background: #ff1900;
}

.meeting-page /deep/ .van-nav-bar__title,
.meeting-page /deep/ .van-nav-bar .van-icon {
  color: #fff;
}

.meeting-page /deep/ .van-hairline--bottom::after {
  border-width: 0;
}

.meeting-list {
  padding: 12px 12px 30px;
}

.meeting-card {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  padding: 16px 14px;
  border: 0;
  border-radius: 8px;
  background: #fff;
  text-align: left;
}

.meeting-card img {
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  margin-right: 10px;
  object-fit: cover;
  border-radius: 6px;
}

.meeting-card span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: #333;
  font-size: 15px;
  line-height: 1.45;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.meeting-card i {
  flex-shrink: 0;
  margin-left: 8px;
  color: #c8c8c8;
  font-style: normal;
  font-size: 18px;
  line-height: 1;
}

.meeting-empty {
  padding: 40px 0;
  color: #999;
  font-size: 14px;
  text-align: center;
}
</style>
